import { home, notifications, options } from 'ionicons/icons'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import LogoutButton from '../../components/LogoutButton'
import { ObjectContext } from '../../contexts/objectContext/ObjectContext'
import PageWrapper from '../../wrappers/pageWrapper/PageWrapper'
import { SettingsCardData } from '../types/settingsCardData'
import ProfileHeaderCard from './components/ProfileHeaderCard'
import ProfileInformationCard from './components/ProfileInformationCard'

const Settings = () => {
	const { hasObjects } = useContext(ObjectContext)

	const { t } = useTranslation('pages_settings')

	const cards: SettingsCardData[] = [
		{
			icon: home,
			label: t('meteringPointSettings'),
			page: 'settings/metering-point',
			isRendered: hasObjects,
		},
		{
			icon: options,
			label: t('appSettings'),
			page: 'settings/application',
		},
		{
			icon: notifications,
			label: t('notificationSettings'),
			page: 'settings/notifications',
		},
	]

	return (
		<PageWrapper page='settings'>
			<ProfileHeaderCard />

			<div className='flex flex-col gap-4 mt-4'>
				{cards.map(cardProps => (
					<ProfileInformationCard
						key={cardProps.label}
						icon={cardProps.icon}
						label={cardProps.label}
						modal={cardProps.modal}
						page={cardProps.page}
						isRendered={cardProps.isRendered}
					/>
				))}
			</div>

			<LogoutButton />
		</PageWrapper>
	)
}

export default Settings
